export default {
  qualitativeSurveys(state) {
    return state.surveys.filter(s => !s.is_spot);
  },

  spotSurveys(state) {
    return state.surveys.filter(s => s.is_spot);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/survey/getters.js